import { useMemo } from "react";
import { capitalizeWord } from "../../../utils";

const styles = {
    urgent: { background: "#dc3545", color: "#ffffff" },
    high: { background: "#dc3545", color: "#ffffff" },
    medium: { background: "#0d6efd", color: "#ffffff" },
    low: { background: "#28a745", color: "#ffffff" },
    default: { background: "#6c757d", color: "#ffffff" },
};

const TaskBadge = ({ text, variant = "High" }) => {

    const badgeStyle = useMemo(() => {
        const variantKey = variant?.toLowerCase();
        return styles[variantKey] || styles["Default"];
    }, [variant]);

    const previewText = useMemo(() => capitalizeWord(text), [text]);

    return (
        <span className="badge rounded-pill px-3 py-2 fw-semibold" style={{ ...badgeStyle, fontSize: "10px" }}>
            {previewText}
        </span>
    );
};

export default TaskBadge;